<template>
  <b-container fluid class="bg-white">
    <div class="row">
      <div class="col-lg lizard-form-empty-col"></div>
    </div>
    <div class="row">
      <div class="col-sm-12 text-left">
        <b-tabs
          pills
          card
          vertical
          class="home-tabs"
          nav-class="lz-home-nav"
          nav-wrapper-class="lz-home-nav-wrapper">
          <b-tab
            v-for="tab in tabs.filter((tab) => tab.show)"
            :key="tab.id"
            :title="tab.title"
            :active="tab.active"
            lazy
            @click="tabChanged(tab.id)">
            <component :is="tab.component" :title="tab.title" />
          </b-tab>
        </b-tabs>
      </div>
    </div>
    <div class="row">
      <div class="col-lg lizard-form-empty-col"></div>
    </div>
  </b-container>
</template>

<script>
import trainingComponent from './training'
import formsComponent from './forms'
import usefulLinksComponent from './useful-links'

export default {
  name: 'HomePanel',
  components: {
    trainingComponent,
    formsComponent,
    usefulLinksComponent
  },
  data() {
    return {
      tabs: [
        {
          id: 'tab_useful_links_component',
          component: 'useful-links-component',
          title: 'Useful Links',
          active: true,
          show: true
        },
        {
          id: 'tab_training_component',
          component: 'training-component',
          title: 'Training Modules',
          active: false,
          show: true
        },
        {
          id: 'tab_forms_component',
          component: 'forms-component',
          title: 'Documents and Forms',
          active: false,
          show: true
        }
      ]
    }
  },
  mounted() {
    this.$root.$on('parent_tab_home_selected', this.tabMounted)
  },
  methods: {
    tabMounted() {
      const selectedTab = this.tabs.find((tab) => tab.active)
      this.tabChanged(selectedTab.id)
    },
    tabChanged(tabId) {
      this.$root.$emit(`${tabId}_selected`)
    }
  }
}
</script>

<style>
/* The nav itself is styled by .lz-home-nav in src/styles/logs.css; only the
   column width is layout-specific and stays here. */
.lz-home-nav-wrapper {
  width: 16% !important;
  min-width: 170px;
}
</style>
